import { ActionSchema, DynamicValueSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { UnderwriterHandoff, type HandoffResult } from './UnderwriterHandoff';

/** The action the console's stage capability claims. */
const STAGE_ACTION_NAME = 'StageViewChanges';

interface ResolvedProps {
  readonly result?: HandoffResult;
  readonly onStage?: () => void;
}

const schema = defineA2uiComponentSchema({
  // ONE object, bound to `/results/<componentId>` and never sent by the agent:
  // rows, accountName, quoteNumber, netPremiumDelta, currency, locale,
  // historical.
  //
  // Seven separate deep bindings (`/results/root/rows` and friends) did not
  // pick up the parent-object write when it first arrived — the data sat in the
  // model while the card rendered `undefined`. CopyQuote and EditQuote, the two
  // surfaces that have always worked, each bind a single object path.
  //
  // The console names each change the way its own quote grid names it, and
  // supplies its own pricing, so none of this may come from the agent.
  result: DynamicValueSchema,
  // Bound by the agent with the change-set as its context, and fired by the
  // component on mount rather than by a click — there is no Apply. Declared
  // here or the binder drops it and nothing ever stages.
  onStage: ActionSchema,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}) as any;

export const UnderwriterHandoffImpl = createComponentImplementation(
  { name: 'UnderwriterHandoff', schema },
  ({
    props,
    context,
  }: {
    props: ResolvedProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    buildChild: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context: any;
  }) => (
    <UnderwriterHandoff
      result={
        props.result && typeof props.result === 'object'
          ? props.result
          : undefined
      }
      onStage={props.onStage}
      // Dispatched from this component so the receipt lands on this card.
      onFollowUp={
        typeof context?.dispatchAction === 'function'
          ? (changeSet: Record<string, unknown>) =>
              context.dispatchAction({
                event: { name: STAGE_ACTION_NAME, context: changeSet },
              })
          : undefined
      }
    />
  )
);
